/*-----------------------------------------------------------------
- Button translations
-----------------------------------------------------------------*/
export default {

    accept   : 'Confirmed',
    cancel   : 'Cancel',
    next     : 'Next',
    back     : 'Previous',
    finish   : 'End',
    load_more: 'Load More',
    confirm  : 'Confirm',

};
